import { ModifiersZTableModel } from '../../table.modifier';
import { TTableOptions, TTableTreeModel } from '../../table.type';

export const TABLE_BAR_MODEL = {
  creatTableModel: (
    config: {
      name: string;
      prop: string;
    }[],
    data: any[],
  ): TTableTreeModel<any> => {
    const headerConfig = config.map((col) => {
      return {
        type: 'TEXT_CELL',
        text: col.name,
      };
    });

    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig,
        sort: true,
      } as unknown as TTableOptions<unknown>,
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: config.map((c) => ({
            type: 'TEXT_CELL',
            text: (item as any)[c.prop],
          })),
        };
      },
    );
  },
};
